import { render } from "./homeFlash.vue?vue&type=template&id=b7ca4ed8&scoped=true"
import script from "./homeFlash.vue?vue&type=script&lang=js"
export * from "./homeFlash.vue?vue&type=script&lang=js"

import "./homeFlash.vue?vue&type=style&index=0&id=b7ca4ed8&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7ca4ed8"]])

export default __exports__